export default __webpack_public_path__ + "static/media/service-booking-not-avail.ac9eb335.svg";